import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Icon } from './Utilities';

export function CreateButton({
  href = null,
  onClick = null,
  size = null,
  primary = false,
  icon = 'plus-hexagon',
  children = 'Create',
  disabled = false,
  loading = false,
  type = 'button',
  style = null,
}) {
  return (
    <G4PButton
      href={href}
      onClick={onClick}
      variant="success"
      size={size}
      primary={primary}
      icon={icon}
      disabled={disabled}
      loading={loading}
      type={type}
      style={style}
    >
      {children}
    </G4PButton>
  );
}

CreateButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string,
  primary: PropTypes.bool,
  icon: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

CreateButton.defaultProps = {
  href: null,
  onClick: null,
  size: null,
  primary: false,
  icon: 'plus-hexagon',
  children: 'Create',
  disabled: false,
  loading: false,
  type: 'button',
  style: null,
};

export function EditButton({
  href = null,
  onClick = null,
  size = null,
  primary = false,
  icon = 'edit',
  children = 'Edit',
  disabled = false,
  loading = false,
  type = 'button',
  style = null,
}) {
  return (
    <G4PButton
      href={href}
      onClick={onClick}
      variant="warning"
      size={size}
      primary={primary}
      icon={icon}
      disabled={disabled}
      loading={loading}
      type={type}
      style={style}
    >
      {children}
    </G4PButton>
  );
}

EditButton.propTypes = { ...CreateButton.propTypes };
EditButton.defaultProps = { ...CreateButton.defaultProps, icon: 'edit', children: 'Edit' };

export function G4PButton({
  href = null,
  onClick = null,
  variant = 'primary',
  size = null,
  primary = false,
  icon = null,
  children = 'Button',
  disabled = false,
  loading = false,
  type = 'button',
  style = null,
}) {
  let iconElement;

  if (icon) {
    iconElement = <Icon icon={loading ? 'sync-alt' : icon} variant="fad" append={`mr-1 ${loading ? 'fa-fw fa-spin' : ''}`} />;
  }

  let buttonElement = (
    <Button
      variant={(primary ? '' : 'outline-') + variant}
      size={size}
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
      style={style}
    >
      {iconElement}
      {children}
    </Button>
  );

  if (href) {
    buttonElement = (
      <a
        className={`btn btn-${primary ? '' : 'outline-'}${variant} ${size ? `btn-${size}` : ''}`}
        href={href}
        style={style}
      >
        {iconElement}
        {children}
      </a>
    );
  }

  return buttonElement;
}

G4PButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  size: PropTypes.string,
  primary: PropTypes.bool,
  icon: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

G4PButton.defaultProps = {
  href: null,
  onClick: null,
  variant: 'primary',
  size: null,
  primary: false,
  icon: null,
  children: 'Button',
  disabled: false,
  loading: false,
  type: 'button',
  style: null,
};
